import { createSlice } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { createCrossword, getCrosswords, updateCrossword, updateWords, deleteCrossword, updateCrosswordStatus, getCrossword, } from '../actions/crosswords';
const initialState = {
    crosswords: [],
    activeFilter: {},
    crosswordDetail: null,
    loading: false,
    error: false,
    errorDetail: '',
    lastCreatedCrosswordId: null,
};
const crosswordsSlice = createSlice({
    name: 'crosswords',
    initialState,
    reducers: {
        setActiveFilter: (state, action) => {
            state.activeFilter = action.payload;
        },
        setlastCreatedCrosswordId: (state, action) => {
            state.lastCreatedCrosswordId = action.payload.crosswordId || null;
        },
        clearError: (state, _action) => {
            state.error = false;
            state.errorDetail = '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCrosswords.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(getCrosswords.fulfilled, (state, action) => {
            state.crosswords = action.payload.crosswords;
            state.loading = false;
            state.error = false;
        })
            .addCase(getCrosswords.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(createCrossword.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(createCrossword.fulfilled, (state, action) => {
            const { crosswordId = v4(), name = '', duration, } = action.payload.crossword;
            const newCrossword = {
                crosswordId,
                name,
                duration,
                status: 'draft',
                wordsCount: 0,
                submissionsCount: 0,
            };
            state.crosswords = [...state.crosswords, newCrossword];
            state.loading = false;
            state.error = false;
            state.lastCreatedCrosswordId = newCrossword.crosswordId;
        })
            .addCase(createCrossword.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(updateCrossword.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(updateCrossword.fulfilled, (state, action) => {
            const { crosswordId, name, duration, settings } = action.payload;
            const crossword = state.crosswords.find((crossword) => crossword.crosswordId === crosswordId);
            if (crossword) {
                crossword.name = name;
                crossword.duration = duration;
            }
            if (state.crosswordDetail) {
                state.crosswordDetail.name = name;
                state.crosswordDetail.duration = duration;
                state.crosswordDetail.settings = settings;
            }
            state.loading = false;
            state.error = false;
        })
            .addCase(updateCrossword.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(getCrossword.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(getCrossword.fulfilled, (state, action) => {
            state.crosswordDetail = action.payload.crossword;
            state.loading = false;
            state.error = false;
        })
            .addCase(getCrossword.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(updateCrosswordStatus.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(updateCrosswordStatus.fulfilled, (state, action) => {
            const { crosswordId, status, code } = action.payload;
            const crossword = state.crosswords.find((crossword) => crossword.crosswordId === crosswordId);
            if (crossword) {
                crossword.status = status;
                crossword.code = code;
            }
            if (state.crosswordDetail) {
                state.crosswordDetail.code = code;
                state.crosswordDetail.status = status;
            }
            state.loading = false;
            state.error = false;
        })
            .addCase(updateCrosswordStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(deleteCrossword.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(deleteCrossword.fulfilled, (state, action) => {
            const { crosswordId } = action.payload;
            state.crosswords = state.crosswords.filter((crossword) => crossword.crosswordId !== crosswordId);
            state.loading = false;
            state.error = false;
        })
            .addCase(deleteCrossword.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        })
            .addCase(updateWords.pending, (state, _action) => {
            state.loading = true;
            state.error = false;
        })
            .addCase(updateWords.fulfilled, (state, action) => {
            const { words, crosswordId, seed } = action.payload;
            if (state.crosswordDetail) {
                state.crosswordDetail.words = words;
                state.crosswordDetail.seed = seed;
            }
            const crossword = state.crosswords.find((crossword) => crossword.crosswordId === crosswordId);
            if (crossword) {
                crossword.wordsCount = words.length;
            }
            state.loading = false;
            state.error = false;
        })
            .addCase(updateWords.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.errorDetail = action.payload || 'An error occurred';
        });
    },
});
export const { setActiveFilter, setlastCreatedCrosswordId, clearError } = crosswordsSlice.actions;
export { crosswordsSlice };
